module.exports = "<div class=\"content-preview\">\n    <a class=\"content-preview__button\" href=\"{{buttonUrl}}\">{{buttonText}}</a>\n    <span class=\"content-preview__info\">\n        {{msgLabel}} \n        <strong>{{#if msgText}}{{msgText}}{{else}}{{msgDefaultText}}{{/if}}</strong>\n    </span>\n</div>";


//////////////////
// WEBPACK FOOTER
// /node_modules/html-loader!/node_modules/@mands/mns-fe-pattern-library/lib/mns-fe-patterns/components/preview-banner/markup.hbs
// module id = 44
// module chunks = 0 1 2 3 4 5 6 7